export default {
  worldPriceTitle: "نمودار قیمت جهانی رمز ارز‌",
  description:
    "این نمودار براساس قیمت های اکسکوینو نیست و صرفا جهت مشاهده روند قیمت جهانی رمز ارزها است"
};
